import { Navigate } from 'react-router-dom';

import { useTypedSelector } from '@hooks/store';
import { projectsGetCurrentProjectName } from '@selectors/projects';

import { ProjectRouteGuardType } from './types';

export const ProjectRouteGuard: ProjectRouteGuardType = (props) => {
  const { children, allowedProjects, redirectTo } = props;
  const currentProjectName = useTypedSelector(projectsGetCurrentProjectName);

  return allowedProjects.includes(currentProjectName ?? '') ? (
    children
  ) : (
    <Navigate replace to={redirectTo} />
  );
};
